"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UTCTimeZone = void 0;
class UTCTimeZone {
    constructor(hours, minutes, isDst = false) {
        /**
         * @inheritDoc
         */
        this.toString = () => {
            const prefix = this.hours < 0 ? "-" : "+";
            return prefix + this.fix(this.hours) + ":" + this.fix(this.minutes);
        };
        this.fix = (num) => {
            const abs = Math.abs(num);
            if (abs < 10) {
                return "0" + abs;
            }
            return abs.toString();
        };
        this.hours = hours;
        this.minutes = minutes;
        this.isDst = isDst;
    }
    /**
     * @inheritDoc
     */
    static z() {
        if (this.zInstance === null) {
            this.zInstance = new UTCTimeZone(0, 0);
        }
        return this.zInstance;
    }
    /**
     * @param timeZoneString /(+|-)\d{2}\:\d{2}/
     */
    static fromString(timeZoneString) {
        return new UTCTimeZone(parseInt(timeZoneString.substr(0, 3)), parseInt(timeZoneString.substr(4, 2)));
    }
}
exports.UTCTimeZone = UTCTimeZone;
// z stands for zulu which is +/- 00:00 timezone
UTCTimeZone.zInstance = null;
//# sourceMappingURL=UTCTimeZone.js.map